module.exports = __webpack_public_path__ + "img/account-settings.37fe118f.svg";